export default {
	main: {
		home: {
			icon: 'home',
		},
		orders: {
			icon: 'shopping-cart',
		},
		shop: {
			icon: 'building-store',
			children: {
				products: {
					icon: 'shopping-bag',
				},
				customers: {
					icon: 'user',
				},

				groups: {
					icon: 'list-details',
				},

				categories: {
					icon: 'checkbox',
				},
/*
				stocks: {
					icon: 'circle',
				},
*/
				recipes: {
					icon: 'receipt',
				},
				recipeCategories: {
					icon: 'receipt-tax',
				},
			},
		},
		marketing: {
			icon: 'percent',
			children: {
				bonusSettings: {
					icon: 'tags',
				},
				bonusHistory: {
					icon: 'bonus-history',
				},
				promocodes: {
					icon: 'number-123',
				},
				historyPromocodes: {
					icon: 'promo-history',
				},
				promotions: {
					icon: 'circle',
				},
				banners: {
					icon: 'rectangle',
				},
				rewards: {
					icon: 'gift',
				},
				jettons: {
					icon: 'badge',
				},
				notifications: {
					icon: 'message',
				},
			},
		},
		statistics: {
			icon: 'activity',
		},
        activity: {
            icon: 'rectangle',
        },
		communications: {
			icon: 'accessible',
			children: {
				reviews: {
					icon: 'star',
				},
				questionReviews: {
					icon: 'questions',
				},
				chats: {
					icon: 'brand-wechat',
				},
				tickets: {
					icon: 'brand-hipchat',
				},
			},
		},
		settings: {
			icon: 'settings',
			children: {
				settings: {
					icon: 'adjustments-horizontal',
				},
				stores: {
					icon: 'flag',
				},
				delivery: {
					icon: 'truck',
				},
				contents: {
					icon: 'book',
				},
				users: {
					icon: 'user-cog',
				},
				import: {
					icon: 'download',
				},
			},
		},
	},

	account: {
		profile: {
			icon: 'user',
		},
		logout: {
			icon: 'power',
			action: 'logout',
		},
	},
}